import React, { Component } from 'react';

import { FormattedPlural } from 'react-intl';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { ListItem } from 'material-ui/List';

import ContextIconMenu from '../Common/ContextIconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import UserGroupIcon from 'material-ui/svg-icons/social/group';

import * as Colors from 'material-ui/styles/colors';
import { statusColours } from '../../constants/ColourConstants';

import UserGroupActions from '../../actions/UserGroupActionCreator';

import ROLES from '../../constants/Roles';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


class UserGroupListItem extends Component {

    render() {

        const row = this.props.data;
        const infoLink = `/dashboard/usergroup/${row.id}`;
        const editLink = `/dashboard/usergroup/${row.id}/edit`;
        const actions = [

            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            { 
                type:'divider'
            },
            {
                link: editLink,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    show: this.context.auth.isRootAdmin()
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete usergroup',
                deleteAction: UserGroupActions.delete,
                message: (
                            <span>
                                Are you sure to delete the usergroup  "{row.name}" ?
                            </span>
                        ),
                condition: {
                    show:  (row.sysStatus > 4 && Number(row.userCount) === 0 && this.context.auth.isRootAdmin())
                }
            }
        ];

        return (

            <ListItem
                style={style.listItem}
                leftAvatar={
                    <Link to={infoLink}>
                        <UserGroupIcon style={style.icon} color={row.userCount > 0 ? statusColours.primary : statusColours.disabled} />
                    </Link>
                    }
                primaryText={
                        <Link to={infoLink} className="primaryText">
                        {row.name}
                        </Link>
                }
                secondaryText={
                    <Link to={infoLink} className="secondaryText">
                        {row.description}<br />
                        {row.userCount}&nbsp;
                            <FormattedPlural
                                value={row.userCount}
                                one='member'
                                other='members'
                            />
                    </Link>
                }
                secondaryTextLines={2}
                rightIcon={
                    <ContextIconMenu
                        actions={actions}
                        data={row}
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton
                                touch={true}
                                style={style.iconButton}
                            >
                                <MoreVertIcon  color={Colors.grey400} />
                            </IconButton>
                        }
                    />
                    }
            />
        )
    }
}

UserGroupListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default UserGroupListItem;
